import type { ImportMode } from "./bpaImport";

export function isEditionLocked(status: string | null | undefined): boolean {
  return status === "live" || status === "archived";
}

export function importBlockedReason(status: string | null | undefined): string | null {
  if (!isEditionLocked(status)) return null;
  return `Imports aren't allowed into ${status === "live" ? "a live" : "an archived"} edition`;
}

export function moveBlockedReason(status: string | null | undefined): string | null {
  if (!isEditionLocked(status)) return null;
  return `Content can't be moved out of ${status === "live" ? "a live" : "an archived"} edition`;
}

export function modeForSource(
  mode: ImportMode,
  sourceEditionStatus: string | null | undefined,
): { mode: ImportMode; notice: string | null } {
  if (mode !== "move") return { mode, notice: null };
  const reason = moveBlockedReason(sourceEditionStatus);
  if (!reason) return { mode, notice: null };
  return { mode: "copy", notice: reason };
}
